import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { ReactComponent as SiteLogoFr } from '../../styles/img/logo_fr.svg';
import { ReactComponent as SiteLogoEn } from '../../styles/img/logo_en.svg';
import { ReactComponent as LocationLogo } from '../../styles/img/icons/location.svg';

const Header = (props: WithTranslation) => {
    const { t, i18n } = props;

    const changeLanguage = (event: React.MouseEvent<HTMLDivElement>) => {
        event.preventDefault();
        i18n.changeLanguage(i18n.language === 'en' ? 'fr' : 'en');
    };

    return (
        <header className="header-container">
            <a
                tabIndex={1}
                id="header_logo_link_aria_label"
                className="header-logo-link"
                href={t('header_main_website')}
            >
                {i18n.language === 'en' ? (
                    <SiteLogoEn
                        aria-label={t('header_logo_aria_label', { ns: 'accessibility' })}
                        role="img"
                        className="header-logo"
                    />
                ) : (
                    <SiteLogoFr
                        aria-label={t('header_logo_aria_label', { ns: 'accessibility' })}
                        role="img"
                        className="header-logo"
                    />
                )}
            </a>
            <div
                tabIndex={2}
                onClick={changeLanguage}
                id="header_language_selection_aria_label"
                className="header-language-container"
                role={'button'}
            >
                <LocationLogo
                    className="header-language-logo"
                    aria-label={t('header_language_selection_aria_label', { ns: 'accessibility' })}
                />
                <div className="header-menu">{t('header_alternate_language')}</div>
            </div>
        </header>
    );
};

export default withTranslation()(Header);
